//Aggregator Endpoints

const aggregatorUrl = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_AGGREGATOR}`;

export const CheckStatus = `${aggregatorUrl}/checkstatus`;

export const UPLOADDATA = `${aggregatorUrl}/devices/uploadDevices`;
export const UPLOADUNITS = `${aggregatorUrl}/devices/batch/db/history`;
export const GET_EVENTS = `${aggregatorUrl}/devices/get-upload-events`;
export const UPLOADREFURBISHED = `${aggregatorUrl}/devices/uploadrefurbisheddata`;

export const VIEWBATCH = `${aggregatorUrl}/viewbatch`;
export const MODIFYBATCH = `${aggregatorUrl}/modifybatch`;
export const GETLOOKUPDATA = `${aggregatorUrl}/get-unassign-camera-esn`;
export const SENDTOREVEAL = `${aggregatorUrl}/sendtoreveal`;
export const UPDATEBATCH = `${aggregatorUrl}/devices/updatebatch`;
export const MANUAL_ACTIVATION = `${aggregatorUrl}/devices/manualActivation`;
export const VENDOR_NAME_LOOKUP = `${aggregatorUrl}/vendorNameLookUp`;
export const INSTALLER_NAME_LOOKUP_VENDOR = `${aggregatorUrl}/installerNameLookUp/vendor`;
export const INSTALLER_NAME_LOOKUP = `${aggregatorUrl}/installerNameLookUp`;
